import type { FC } from 'react';
import type { Channel, ChannelPaymentMethod } from '../../../model';
import { Spinner, Switch } from '../../../components';

interface Props {
  canEdit: boolean;
  channel: Channel;
  paymentMethods: ChannelPaymentMethod[];
  isChannelPending: boolean;
  pendingPaymentMethodId?: number;

  onToggleChannel(channel: Channel): void;

  onTogglePaymentMethod(paymentMethod: ChannelPaymentMethod): void;
}

export const ChannelCard: FC<Props> = ({
  canEdit,
  channel,
  paymentMethods,
  isChannelPending,
  pendingPaymentMethodId,
  onToggleChannel,
  onTogglePaymentMethod,
}) => (
  <li className="grid grid-cols-2 gap-6 items-start">
    <div className="flex items-center gap-4">
      <div className="flex-1 flex justify-between items-center gap-2 border border-brand-1/30 rounded-lg px-4 py-2">
        <span className="font-medium">{channel.name}</span>
        <span className="text-brand-2 text-xs uppercase">{channel.flowType}</span>
      </div>
      {canEdit && (
        <Switch
          checked={channel.isEnable}
          disabled={isChannelPending}
          onClick={() => onToggleChannel(channel)}
        />
      )}
      {isChannelPending && <Spinner className="h-4 w-4" />}
    </div>

    <ul className="grid gap-2">
      {paymentMethods.map((paymentMethod) => (
        <li className="flex items-center gap-4" key={paymentMethod.id}>
          <div className="flex-1 border border-brand-1/30 rounded-lg px-4 py-2">
            {paymentMethod.name}
          </div>
          {canEdit && (
            <Switch
              checked={paymentMethod.isEnable}
              disabled={pendingPaymentMethodId === paymentMethod.id}
              onClick={() => onTogglePaymentMethod(paymentMethod)}
            />
          )}
          {pendingPaymentMethodId === paymentMethod.id && <Spinner className="h-4 w-4" />}
        </li>
      ))}
      {paymentMethods.length === 0 && (
        <li className="text-brand-2 text-sm py-2">No payment methods</li>
      )}
    </ul>
  </li>
);
